export const GET_PROBLEMS_REQUEST = 'PROBLEMS.GET_PROBLEMS_REQUEST';
export const GET_PROBLEMS_SUCCESS = 'PROBLEMS.GET_PROBLEMS_SUCCESS';
export const GET_PROBLEMS_ERROR = 'PROBLEMS.GET_PROBLEMS_ERROR';

export const GET_PROBLEMS_IN_COURSE_REQUEST = 'PROBLEMS.GET_PROBLEMS_IN_COURSE_REQUEST';
export const GET_PROBLEMS_IN_COURSE_SUCCESS = 'PROBLEMS.GET_PROBLEMS_IN_COURSE_SUCCESS';
export const GET_PROBLEMS_IN_COURSE_ERROR = 'PROBLEMS.GET_PROBLEMS_IN_COURSE_ERROR';

export const REMOVE_PROBLEM_USAGE = 'PROBLEMS.REMOVE_PROBLEM_USAGE';
